// start:ng42.barrel
export * from './submit-review.module';
export * from './submit-review/';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/submit-review/index.ts